import {
	reRequestsStatusConstants
}from './constants'
import api from './api'
import { defAction } from '../../../helpers/defaultAction'

export const reRequestStatusActions = {
	getRequestsStatus,
	getRequestsStatusViews,
	getRequestStatusByName,
	createRequestStatus,
	deleteRequestStatus,
	updateRequestStatus,
	restoreRequestStatus,
	clearRequestStatus
}

function getRequestsStatus(params){
	return dispatch => {
		dispatch(request())

		api.getRequestsStatus(params).then(res => {
			dispatch(success(res))
		})
			.catch(e => {
				dispatch(failure(e))
			})

		function request(){
			return {
				type: reRequestsStatusConstants.SEND_REREQUESTSSTATUS_REQUEST
			}
		}
		function success(reqStatus){
			return {
				type    : reRequestsStatusConstants.SEND_REREQUESTSSTATUS_SUCCESS,
				payload : reqStatus
			}
		}
		function failure(error){
			return {
				type    : reRequestsStatusConstants.SEND_REREQUESTSSTATUS_FAILURE,
				payload : error
			}
		}
	}
}

function getRequestsStatusViews(params){
	return dispatch => {
		dispatch(request())

		api.getRequestsStatusViews(params).then(res => {
			dispatch(success(res))
		})
			.catch(e => {
				dispatch(failure(e))
			})

		function request(){
			return {
				type: reRequestsStatusConstants.SEND_REREQUESTSSTATUS_REQUEST
			}
		}
		function success(reqStatus){
			return {
				type    : reRequestsStatusConstants.SEND_REREQUESTSSTATUS_SUCCESS,
				payload : reqStatus
			}
		}
		function failure(error){
			return {
				type    : reRequestsStatusConstants.SEND_REREQUESTSSTATUS_FAILURE,
				payload : error
			}
		}
	}
}

function getRequestStatusByName(params){
	return dispatch => {
		dispatch(request())

		api.getRequestStatusByName(params).then(res => {
			dispatch(success(res))
		})
			.catch(e => {
				dispatch(failure(e))
			})

		function request(){
			return {
				type: reRequestsStatusConstants.SEND_REREQUESTSSTATUS_REQUEST
			}
		}
		function success(reqStatus){
			return {
				type    : reRequestsStatusConstants.SEND_REREQUESTSSTATUS_SUCCESS,
				payload : reqStatus
			}
		}
		function failure(error){
			return {
				type    : reRequestsStatusConstants.SEND_REREQUESTSSTATUS_FAILURE,
				payload : error
			}
		}
	}
}
function createRequestStatus(params){
	const dispatchObj = {
		constants: reRequestsStatusConstants.createRequestStatus,
		service: {
		  func: api.createRequestStatus,
		  params: params,
		},
	  }
	
	  return defAction(dispatchObj)
}

function deleteRequestStatus(params){
	const dispatchObj = {
		constants: reRequestsStatusConstants.deleteRequestStatus,
		service: {
		  func: api.deleteRequestStatus,
		  params: params,
		},
	  }
	
	  return defAction(dispatchObj)
}

function updateRequestStatus(params){
	const dispatchObj = {
		constants: reRequestsStatusConstants.updateRequestStatus,
		service: {
		  func: api.updateRequestStatus,
		  params: params,
		},
	  }
	
	  return defAction(dispatchObj)
}

function restoreRequestStatus(params){
	const dispatchObj = {
		constants: reRequestsStatusConstants.restoreRequestStatus,
		service: {
		  func: api.restoreRequestStatus,
		  params: params,
		},
	  }
	
	  return defAction(dispatchObj)
}

function clearRequestStatus() {
	return (dispatch) =>
	dispatch({
	  type: reRequestsStatusConstants.SEND_REREQUESTSSTATUS_CLEAR,
	})
  }